import { useEffect } from 'react'
import { getCustomData } from 'shared/components/App/Auth'
import Store from 'redux/Store'
import { setFilterRoleName } from 'redux/actions'

interface useInitCentersProps {
  getRows: Function
  setRows: Function
  setCurrentFilterRole: Function
  setDataLoaded: Function
  filterRoleName: string
}

const useInit = (props: useInitCentersProps) => {
  useEffect(() => {
    props.getRows().then((data: any) => {
      props.setRows(data.filterRoles)
      const currentFilterRole = data.selectedFilterRole ?? getCustomData('filterRole')
      const filterRoleObj = data.filterRoles.find((row) => row.id === currentFilterRole?.data.id)
      if (typeof filterRoleObj !== 'undefined') {
        props.setCurrentFilterRole(filterRoleObj)
        Store.dispatch(setFilterRoleName(filterRoleObj.name))
      }
      props.setDataLoaded(true)
    })
  }, [])
}

export default useInit
